import Layout from 'app/pages/Layout/Layout';
import React from 'react';

const Home = React.lazy(() => import('app/pages/Home/Home'));
const Services = React.lazy(() => import('app/pages/Services/Services'));
const Order = React.lazy(() => import('app/pages/Order/Order'));
const MyTrips = React.lazy(() => import('app/pages/MyTrips/MyTrips'));
const Summary = React.lazy(() => import('app/pages/Summary/Summary'));
const Contact = React.lazy(() => import('app/pages/Contact/Contact'));
const CancelTrip = React.lazy(() => import('app/pages/CancelTrip/CancelTrip'));

interface BaseRoute {
  path: string;
  exact?: boolean;
  children?: IRouteItem[] | null;
}

interface ComponentRoute extends BaseRoute {
  component: React.FC;
}

interface JSXRoute extends BaseRoute {
  jsx: React.ReactNode;
}

export type IRouteItem = ComponentRoute | JSXRoute;

export enum Routes {
  Services = '/services',
  Book = '/checkout',
  Trips = '/trips',
  Summary = '/summary',
  Contact = '/contact',
  CancelTrip = '/cancelJob',
}

// prettier-ignore
const routes: IRouteItem[] = [
  { path: Routes.CancelTrip,    component: CancelTrip,              },
  { path: '/',                  component: Layout,        children: [
    { path: '/',                component: Home,                    },
    { path: Routes.Services,    component: Services                 },
    { path: Routes.Book,        component: Order                    },
    { path: Routes.Trips,       component: MyTrips                  },
    { path: Routes.Summary,     component: Summary                  },
    { path: Routes.Contact,     component: Contact                  },
    { path: Routes.CancelTrip,  component: CancelTrip               },
  ]}
];

export default routes;
